/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';

import { rootUiActions } from 'app-components/flux/root-ui';
import ConfirmationDialog from '../ConfirmationDialog';

export { DIALOG_TYPE, mkRefreshTimeoutDialogProps } from './types';
export { mkConfirmationDialogProps } from '../ConfirmationDialog/types';

class RefreshTimeoutDialog extends React.PureComponent {
  handleClose = () => {
    if (this.props.dialogIdsToClose) {
      this.props.dialogIdsToClose.forEach((id) => this.props.removeDialog(id));
    }
  };

  render() {
    return (
      <ConfirmationDialog
        {...(this.props.confirmationDialogProps?.toJS?.() || this.props.confirmationDialogProps)}
        dialogId={this.props.dialogId}
        onClose={this.handleClose}
        sharedcomponentid={'DIALOG_REFRESH_TIMEOUT'}
      />
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    removeDialog: (dialogId) => dispatch(rootUiActions.removeDialog(dialogId)),
  };
}

export default connect(null, mapDispatchToProps)(RefreshTimeoutDialog);
